export default "__VITE_ASSET__26620f09__"